/* _UserMessage.js — TIMECLOCK UserMessage.cfm (multi-instance; one interval per data-uim-instance) */

(function (global, $) {
  'use strict';

  var POLL_MS = 500;
  var instances = Object.create(null);

  function root$(instanceUuid) {
    if (!instanceUuid || !$) {
      return $();
    }
    // Prefer data-uim-instance: first server message may use id="UserUIMessage" (legacy); others use UserUIMessage_<uuid>
    return $('.userUIMessageWrapper[data-uim-instance="' + instanceUuid + '"]');
  }

  function stopAutoHide(instanceUuid) {
    var inst = instances[instanceUuid];
    if (inst) {
      clearInterval(inst.intervalId);
      delete instances[instanceUuid];
    }
  }

  /**
   * Hides and removes one message instance (by server CreateUUID on the wrapper).
   */
  function hideUserUIMessage(instanceUuid) {
    if (!instanceUuid) {
      return;
    }
    stopAutoHide(instanceUuid);
    var $root = root$(instanceUuid);
    if (!$root.length) {
      return;
    }
    $root.slideUp(1000, function () {
      $(this).remove();
    });
  }

  /**
   * Toggle additional details panel (uuid from AdditionalDetails block).
   */
  function toggleAdditionalDetails(detailsUuid) {
    if (!detailsUuid) {
      return;
    }
    var el = document.getElementById('additionalResponseDetails_' + detailsUuid);
    var toggleLink = document.getElementById('toggle_' + detailsUuid);
    if (!el) {
      return;
    }
    var isHidden = el.style.display === 'none' || window.getComputedStyle(el).display === 'none';
    el.style.display = isHidden ? 'block' : 'none';
    if (toggleLink) {
      toggleLink.classList.toggle('is-open', isHidden);
    }
  }

  function doAutohideTick(instanceUuid, hideCountMax) {
    var state = instances[instanceUuid];
    if (!state) {
      return;
    }
    state.tickCount += 1;
    if (state.tickCount >= hideCountMax) {
      hideUserUIMessage(instanceUuid);
    }
  }

  function initAutoHide(instanceUuid, hideCountMax) {
    var hideMax = parseInt(hideCountMax, 10);
    if (isNaN(hideMax) || hideMax < 1) {
      hideMax = 25;
    }
    stopAutoHide(instanceUuid);
    var state = { tickCount: 0, intervalId: null };
    instances[instanceUuid] = state;
    function tick() {
      doAutohideTick(instanceUuid, hideMax);
    }
    $(tick);
    state.intervalId = setInterval(tick, POLL_MS);
  }

  /**
   * Binds autohide timers for wrappers not yet processed (e.g. after AJAX inject).
   */
  function scanAutoHideRoots(rootNode) {
    var $ctx = rootNode ? $(rootNode) : $(document);
    var $nodes = $ctx.find('.userUIMessageWrapper[data-uim-autohide="true"]').add(
      $ctx.filter('.userUIMessageWrapper[data-uim-autohide="true"]')
    );
    $nodes.each(function () {
      var $w = $(this);
      if ($w.attr('data-uim-js-bound') === '1') {
        return;
      }
      var instanceUuid = $w.attr('data-uim-instance');
      if (!instanceUuid) {
        return;
      }
      var hideCount = $w.attr('data-uim-hide-count') || '25';
      $w.attr('data-uim-js-bound', '1');
      initAutoHide(instanceUuid, hideCount);
    });
  }

  $(function () {
    scanAutoHideRoots(document);
  });

  $(document)
    .on('click', '.userUIMessageWrapper a.js-userUIMessage-close', function (e) {
      e.preventDefault();
      var instanceUuid = $(this).closest('.userUIMessageWrapper').attr('data-uim-instance');
      hideUserUIMessage(instanceUuid);
    })
    .on('click', 'a.js-userUIMessage-toggleDetails', function (e) {
      e.preventDefault();
      var detailsUuid = $(this).attr('data-details-uuid');
      toggleAdditionalDetails(detailsUuid);
    });

  global.hideUserUIMessage = hideUserUIMessage;
  global.toggleAdditionalDetails = toggleAdditionalDetails;
  global.UserUIMessage = {
    scanAutoHideRoots: scanAutoHideRoots,
    hide: hideUserUIMessage,
    toggleDetails: toggleAdditionalDetails
  };
})(typeof window !== 'undefined' ? window : this, jQuery);
